import PropTypes from 'prop-types';
import React, { Component } from 'react';
import find from 'lodash/find';
import classNames from 'classnames/bind';
import YodaDropdown from 'yoda-site-components/lib/components/YodaDropdown/YodaDropdown';
import YdtSort from 'yoda-core-components/lib/assets/svg/YdtSort.svg';
import Icon from 'yoda-core-components/lib/components/Icon';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './SortPanel.css';

const cx = classNames.bind(styles);

class SortPanel extends Component {
    static propTypes = {
        getListCategorySort: PropTypes.func.isRequired,
        preferences: PropTypes.object,
        authStatus: PropTypes.object,
        isMyFavourites: PropTypes.bool,
        disabled: PropTypes.bool,
        value: PropTypes.string,
        listId: PropTypes.string,
        deviceType: PropTypes.string,
    };

    static defaultProps = {
        preferences: {},
        authStatus: false,
        isMyFavourites: false,
        disabled: false,
        value: '',
        listId: '',
        deviceType: '',
    };

    constructor(props) {
        super(props);
        this.state = {
            selectVal: props.value,
            listId: props.listId,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(selectVal) {
        const { listId } = this.state;
        this.props.getListCategorySort({ sort: selectVal, listId });
        this.setState({ selectVal });
    }

    parseSortOptions = (sortOptions) =>
        sortOptions.map((item) => ({
            displayKey: item.name,
            value: item.value,
        }));

    getSelectedValue = (listCategory, isMobile) => {
        const { selectVal } = this.state;
        /* istanbul ignore if */
        if (selectVal) {
            const data = find(listCategory, (item) => item.value === selectVal);
            return isMobile ? data.value : data.name;
        }
        return listCategory[0].name;
    };

    sortBtn = () => {
        const { preferences, authStatus, isMyFavourites, disabled, deviceType } = this.props;
        let listCategory;
        const { newpref = preferences } = preferences;
        if (isMyFavourites) {
            listCategory = newpref.favListCategory;
        } else {
            listCategory = authStatus ? newpref.listCategoryAuth : newpref.listCategoryGuest;
        }
        const disableSort = disabled
            ? dt([
                  'bg-light-white',
                  'border-dashed',
                  'pointer-events-none',
                  '!border-gray-25',
                  '!text-gray-40',
              ])
            : '';

        return (
            <>
                {deviceType && (deviceType.isDesktop || deviceType.isTablet) && (
                    <div
                        className={`${dt([
                            'hidden',
                            'md:inline-block',
                            'relative',
                            'border',
                            'border-solid',
                            'border-gray-60',
                            'rounded-lg',
                            'ml-6',
                            'mdOnly:w-max',
                            disableSort,
                        ])} ${cx('sort-wrapper-desktop')}`}
                    >
                        <YodaDropdown
                            dataSource={this.parseSortOptions(listCategory)}
                            defaultValue={this.getSelectedValue(listCategory)}
                            forceDesktop
                            dropdownLabel="Sort by: "
                            onChange={this.handleChange}
                            automationId="sortDropdown"
                            dropdownTheme={dt(['!w-full', '!mt-[5px]', '!mr-[3px]'])}
                            theme={dt([
                                '!inline-block',
                                '!static',
                                '!w-full',
                                '!h-full',
                                'pt-1.5',
                                disabled ? 'pb-3' : 'pb-1.5',
                            ])}
                            mobileTheme={dt(['md:!hidden'])}
                            iconClassName={dt(['!ml-2', '!mr-4'])}
                            tooltipWrapper={dt(['!w-full'])}
                            labelTheme={dt(['!text-base', '!leading-6'])}
                            sortByLabel={dt(['!normal-case'])}
                            isDisabled={disabled}
                        />
                    </div>
                )}
                {deviceType && deviceType.isMobile && (
                    <div
                        className={dt([
                            'md:hidden',
                            'text-center',
                            'border',
                            'border-solid',
                            'border-gray-40',
                            'rounded-lg',
                            'sm:block',
                            'relative',
                            'w-full',
                            'h-10',
                            'pb-2',
                            'mt-4',
                            disableSort,
                        ])}
                    >
                        <label
                            htmlFor="sortByFilter"
                            className={dt(['cursor-pointer', 'w-full', 'align-middle'])}
                        >
                            <div
                                className={dt([
                                    'inline-flex',
                                    'text-normal',
                                    'align-middle',
                                    'font-semibold',
                                ])}
                            >
                                <Icon height="24" width="24">
                                    <YdtSort />
                                </Icon>
                                <span className={dt(['ml-2'])}>Sort</span>
                            </div>
                        </label>
                        <YodaDropdown
                            dataSource={this.parseSortOptions(listCategory)}
                            defaultValue={this.getSelectedValue(listCategory, true)}
                            isMobileViewinDesktop
                            onChange={this.handleChange}
                            automationId="sortDropdown-mobile"
                            mobileTheme={dt([
                                'opacity-0',
                                'sm:overflow-hidden',
                                'z-[4]',
                                'h-full',
                                'block',
                                '-mt-6',
                                'w-full',
                            ])}
                            id="sortByFilter"
                            selectOptionClassName={dt(['w-full'])}
                            labelTheme={dt(['hidden'])}
                            iconClassName={dt(['hidden'])}
                        />
                    </div>
                )}
            </>
        );
    };

    render() {
        return this.sortBtn();
    }
}

export default SortPanel;
